export class SelfAssessmentT2 {
    id: number;
    rulebookRuleID: string;
    libraryName: string;
    title: string;
    geography: string;
    country: string;
    regulator: string;
    effectiveDate: string;
    ruleBook: string;
    title1: string;
    title2: string;
    title3: string;
    title4: string;
    title5: string;
    ruleID: string;
    regulatoryRuleFullRequirement: string;
    hyperlink: string;
    insertedRow: number;
    editableRow: number;
    ruleApplicable: string;
    rationaleifNo: string;
    assessmentTeam: string;
    assessor: string;
    assessorDelegate: string;
    assessmentDetails: string;
    assessmentLastEdited: Date | null;
    assessmentDueDate: Date | null;
    assessmentStatus: string;
    reviewTeam: string;
    reviewer: string;
    reviewerDelegate: string;
    reviewDetails: string;
    reviewLastEdited: Date | null;
    reviewDueDate: Date | null;
    reviewStatus: string;
    overallStatus: string;
    overallConclusion: string;
    ruleConclusion: string;
    gapDescription: string;
    gapReviewStatus: string;
    actionTeam: string;
    actionOwner: string;
    remediationAction: string;
    actionLastEdited: Date | null;
    actionDueDate: Date | null;
    actionStatus: string;
    closureRationale: string;
    enhancementDescription: string;
    enhancementReviewStatus: string;
    enhancementActionTeam: string;
    enhancementActionOwner: string;
    enhancementAction: string;
    enhancementActionLastEdited: Date | null;
    enhancementActionDueDate: Date | null;
    enhancementActionStatus: string;
    versionNumber: number;
    userId: string;
    userName: string;
    part:string;
    owner:string;
    isSendNotification: boolean;
    createdDateTime: Date | null;


    constructor() {
        this.id = 0;
        this.rulebookRuleID = '';
        this.libraryName = '';
        this.title = '';
        this.geography = '';
        this.country = '';
        this.regulator = '';
        this.effectiveDate = '';
        this.ruleBook = '';
        this.title1 = '';
        this.title2 = '';
        this.title3 = '';
        this.title4 = '';
        this.title5 = '';
        this.ruleID = '';
        this.regulatoryRuleFullRequirement = '';
        this.hyperlink = '';
        this.insertedRow = 0;
        this.editableRow = 0;
        this.ruleApplicable = '';
        this.rationaleifNo = '';
        this.assessmentTeam = '';
        this.assessor = '';
        this.assessorDelegate = '';
        this.assessmentDetails = '';
        this.assessmentLastEdited =  null;
        this.assessmentDueDate = null;
        this.assessmentStatus = '';
        this.reviewTeam = '';
        this.reviewer = '';
        this.reviewerDelegate = '';
        this.reviewDetails = '';
        this.reviewLastEdited = null;
        this.reviewDueDate = null;
        this.reviewStatus = '';
        this.overallStatus = '';
        this.overallConclusion = '';
        this.ruleConclusion = '';
        this.gapDescription = '';
        this.gapReviewStatus = '';
        this.actionTeam = '';
        this.actionOwner = '';
        this.remediationAction = '';
        this.actionLastEdited = null;
        this.actionDueDate = null;
        this.actionStatus = '';
        this.enhancementDescription = '';
        this.enhancementReviewStatus = '';
        this.enhancementActionTeam = '';
        this.enhancementActionOwner = '';
        this.enhancementAction = '';
        this.enhancementActionLastEdited = null;
        this.enhancementActionDueDate = null;
        this.enhancementActionStatus = '';
        this.closureRationale = '';
        this.versionNumber = 0;
        this.userId = '';
        this.userName = '';
        this.part = '';
        this.owner = '';
        this.isSendNotification = false;
        this.createdDateTime = null;
    }
}

export class BulkSelfAssessmentT2 {
    id: number;
    //Rule Details
    rulebookRuleID: string;
    part:string;
    regulator: string;
    effectiveDate: string;
    ruleBook: string;
    ruleID: string;
    regulatoryRuleFullRequirement: string;

    //Key Information
    owner:string;

    //Overall Assessment
    assessmentDueDate: Date | null;
    assessmentCategory: string;
    assessmentDescription: string;
    assessmentTeam: string;
    assessor: string;
    assessmentStatus: string;
    complianceStatus: string;
    assessmentLastEdited: Date | null;
    assessmentDetails: string;

    //Interpretations
    interpretation: string;
    interpretationLastEdited : Date | null;
    interpretationDetails : string;

    //Data Judgements
    judgement : string;
    judgementLastEdited: Date | null;
    noOfJudgements :number;
    judgementDetails : string;

    //Compliance Gaps
    gaps : string;
    gapsLastEdited : Date | null;
    noOfGaps : number;
    noOfGapsRiskAccepted : number;
    gapDetail:string;
    gapActionDueDate:Date | null;

    //EnhancementDetails
    enhancement : string;
    enhancementLastEdited: Date | null;
    noOfEnhancement:number;
    riskRecommendation:string;
    riskRecommendationDueDate: Date | null;
    riskRecommendationStatus : string;
    enhancementDescription: string;

    //Review Details
    reviewerTeam : string;
    reviewer: string;
    reviewStatus: string;
    reviewLastEdited: Date | null;
    reviewDetails: string;

    //Approval Details
    approvalTeam : string;
    approvers : string;
    approvalStatus:string;
    confirmApproval : string;
    approvalLastEdited : Date | null;
    lastApproved : Date | null;
    approvalComment : string;

    //Extra Fields
    libraryName: string;
    title: string;
    geography: string;
    country: string;
    hyperlink: string;
    versionNumber: number;
    userId: string;
    userName: string;
    isSendNotification: boolean;
    title1:string;

    constructor() {
        this.id = 0;
        this.rulebookRuleID = '';
        this.libraryName = '';
        this.title = '';
        this.geography = '';
        this.country = '';
        this.judgement = '';
        this.judgementLastEdited = null;
        this.noOfJudgements = 0;
        this.judgementDetails = '';
        this.approvalLastEdited = null;
        this.regulator = '';
        this.effectiveDate = '';
        this.ruleBook = '';
        this.riskRecommendationStatus = '';
        this.riskRecommendationDueDate = null;
        this.ruleID = '';
        this.regulatoryRuleFullRequirement = '';
        this.approvalTeam = '';
        this.assessmentCategory = '';
        this.hyperlink = '';
        this.approvers = '';
        this.riskRecommendation = '';
        this.confirmApproval = '';
        this.approvalStatus = '';
        this.assessmentDescription = '';
        this.assessmentTeam = '';
        this.assessor = '';
        this.assessmentDetails = '';
        this.assessmentLastEdited =  null;
        this.assessmentDueDate = null;
        this.assessmentStatus = '';
        this.reviewerTeam = '';
        this.reviewer = '';
        this.reviewDetails = '';
        this.reviewLastEdited = null;
        this.reviewStatus = '';
        this.enhancementDescription = '';
        this.enhancementLastEdited = null;
        this.versionNumber = 0;
        this.userId = '';
        this.userName = '';
        this.part = '';
        this.owner = '';
        this.isSendNotification = false;
        this.complianceStatus = '';
        this.interpretation = '';
        this.interpretationLastEdited = null;
        this.interpretationDetails = '';
        this.gaps = '';
        this.gapsLastEdited = null;
        this.noOfGaps = 0;
        this.noOfGapsRiskAccepted = 0;
        this.gapDetail = '';
        this.enhancement = '';
        this.noOfEnhancement = 0;
        this.lastApproved = null;
        this.approvalComment = '';
        this.title1 = '';
        this.gapActionDueDate = null;
    }
}

export class SelfAssessmentNew {
    id: number;
    //Rule Details
    rulebookRuleID: string;
    part:string;
    regulator: string;
    effectiveDate: string;
    ruleBook: string;
    ruleID: string;
    regulatoryRuleFullRequirement: string;

    //Key Information
    owner:string;

    //Overall Assessment
    assessmentCreationDate: Date | null;
    assessmentDueDate: Date | null;
    assessmentCategory: string;
    assessmentDescription: string;
    assessmentTeam: string;
    assessor: string;
    assessmentStatus: string;
    complianceStatus: string;
    assessmentLastEdited: Date | null;
    assessmentDetails: string;

    //Interpretations
    interpretation: string;
    interpretationLastEdited : Date | null;
    interpretationDetails : string | null;

    //Data Judgements
    judgement : string;
    judgementLastEdited: Date | null;
    noOfJudgements :number;
    judgementDetails : string;

    //Compliance Gaps
    gaps : string;
    gapsLastEdited : Date | null;
    noOfGaps : number;
    noOfGapsRiskAccepted : number;
    gapDetail:string;
    gapActionDueDate:Date | null;

    //EnhancementDetails
    enhancement : string;
    enhancementLastEdited: Date | null;
    noOfEnhancement:number;
    riskRecommendation:string;
    riskRecommendationDueDate: Date | null;
    riskRecommendationStatus : string;
    enhancementDescription: string;

    //Review Details
    reviewerTeam : string;
    reviewer: string;
    reviewStatus: string;
    reviewLastEdited: Date | null;
    reviewDetails: string;

    //Approval Details
    approvalTeam : string;
    approvers : string;
    approvalStatus:string;
    confirmApproval : string;
    approvalLastEdited : Date | null;
    lastApproved : Date | null;
    approvalComment : string;

    //Extra Fields
    libraryName: string;
    title: string;
    geography: string;
    country: string;
    hyperlink: string;
    versionNumber: number;
    userId: string;
    userName: string;
    isSendNotification: boolean;
    title1:string;
    createdDateTime:Date|null;
    muteOverallStatusUser:string;
    muteReviewUser:string;
    muteApproverUser:string;
    jurisdiction:string;
    jurisdictionId: number;

    constructor() {
        this.id = 0;
        this.rulebookRuleID = '';
        this.libraryName = '';
        this.title = '';
        this.geography = '';
        this.country = '';
        this.judgement = '';
        this.judgementLastEdited = null;
        this.noOfJudgements = 0;
        this.judgementDetails = '';
        this.approvalLastEdited = null;
        this.regulator = '';
        this.effectiveDate = '';
        this.ruleBook = '';
        this.riskRecommendationStatus = '';
        this.riskRecommendationDueDate = null;
        this.ruleID = '';
        this.regulatoryRuleFullRequirement = '';
        this.approvalTeam = '';
        this.assessmentCategory = '';
        this.hyperlink = '';
        this.approvers = '';
        this.riskRecommendation = '';
        this.confirmApproval = '';
        this.approvalStatus = '';
        this.assessmentDescription = '';
        this.assessmentTeam = '';
        this.assessor = '';
        this.assessmentDetails = '';
        this.assessmentLastEdited =  null;
        this.assessmentDueDate = null;
        this.assessmentStatus = '';
        this.reviewerTeam = '';
        this.reviewer = '';
        this.reviewDetails = '';
        this.reviewLastEdited = null;
        this.reviewStatus = '';
        this.enhancementDescription = '';
        this.enhancementLastEdited = null;
        this.versionNumber = 0;
        this.userId = '';
        this.userName = '';
        this.part = '';
        this.owner = '';
        this.isSendNotification = false;
        this.assessmentCreationDate = null;
        this.complianceStatus = '';
        this.interpretation = '';
        this.interpretationLastEdited = null;
        this.interpretationDetails = '';
        this.gaps = '';
        this.gapsLastEdited = null;
        this.noOfGaps = 0;
        this.noOfGapsRiskAccepted = 0;
        this.gapDetail = '';
        this.enhancement = '';
        this.noOfEnhancement = 0;
        this.lastApproved = null;
        this.approvalComment = '';
        this.title1 = '';
        this.createdDateTime = null;
        this.muteOverallStatusUser ="";
        this.muteReviewUser="";
        this.muteApproverUser="";
        this.jurisdiction = "";
        this.jurisdictionId = 0;
        this.gapActionDueDate = null;
    }
}
export class ConfirmApprove{
    approverName:string;
    isConfirmed:boolean;

    constructor(){
        this.approverName = '';
        this.isConfirmed = false;
    }
}
